var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AuthService from "../services/auth";
export class AuthController {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.auth = new AuthService(baseUrl);
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.logout();
            return res;
        });
    }
    saveOauthUser({ userOauthId, isPasswordRequired, password, platform, accessToken, triaNameHash, pin, encyRandomNumber, salt, shard, triaName }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.saveOauthUser({ userOauthId: userOauthId, triaName: triaName, isPasswordRequired, password, platform, accessToken, triaNameHash, encyRandomNumber, pin, salt, shard });
            return res;
        });
    }
    getKey(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.getKey(accessToken);
            return res;
        });
    }
    checkLinkEmailExists({ email }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.checkLinkEmailExists({ email });
            return res;
        });
    }
    initiateCognitoAuth({ input, password, origin, verificationType, isPasswordLess }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.initiateCognitoAuth({ input, password, origin, verificationType, isPasswordLess });
            return res;
        });
    }
    verifyCognitoAuth({ input, code, isPasswordLess, session, verificationType }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.verifyCognitoAuth({ input, code, isPasswordLess, session, verificationType });
            return res;
        });
    }
    getRecoveryShard({ accessToken, pin, idToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.getRecoveryShard({ accessToken, pin, idToken });
            return res;
        });
    }
    setupPin({ accessToken, pin, idToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.setupPin({ accessToken, pin, idToken });
            return res;
        });
    }
    isPinSetup({ accessToken, idToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.auth.isPinSetup({ accessToken, idToken });
            return res;
        });
    }
}
